//https://www.gstatic.com/firebasejs/7.14.2/firebase-app.js
//https://www.gstatic.com/firebasejs/7.14.2/firebase-messaging.js
//https://firebase.google.com/docs/reference/js/firebase.messaging.Messaging

import store from './store/store'
import * as varSlice from './features/var/varSlice'
import * as activeVarList from './features/activeVarsList/activeVarsListSlice'
import * as pendingVarList from './features/pendingVarsList/pendingVarsListSlice'
import * as historyVarList from './features/historyVarsList/historyVarsListSlice'
import firebase from 'firebase/compat/app'
import 'firebase/compat/messaging'

const PlntFcmp = {
    defaultApp: null,
    messaging: null,
    setAlertMessage: null,
    setAlertActive: null,
    lastUpdateList: Date.now(),
    updateListInterval: 60000, //millis
    init: function (firebaseConfig, setAlertMessage, setAlertActive) { //PublicVapidKey, 
        PlntFcmp.log('init()');
        try {
            PlntFcmp.log(firebase, firebase.messaging);
            if (!firebase.apps.length) {
                PlntFcmp.defaultApp = firebase.initializeApp(firebaseConfig);
                PlntFcmp.messaging = firebase.messaging();
                //PlntFcmp.messaging.usePublicVapidKey(PublicVapidKey);
            } else {
                PlntFcmp.defaultApp = firebase.app();
            }
            PlntFcmp.setAlertMessage = setAlertMessage;
            PlntFcmp.setAlertActive = setAlertActive;
        } catch (err) {
            PlntFcmp.log(err)
        }

        if (PlntFcmp.messaging === null || PlntFcmp.messaging === undefined) {
            PlntFcmp.log('Init not possible, client can\'t provide this functionality.');
            return;
        }

        if (window.localStorage.getItem('lastNotificationPermission') !== Notification.permission) {
            PlntFcmp.log('FORZA IL SEND AL SERVER');
            PlntFcmp.setTokenSentToServer(false);
            window.localStorage.setItem('lastNotificationPermission', Notification.permission);
        }

        //PlntFcmp.messaging.onTokenRefresh(function () {
        //    PlntFcmp.messaging.getToken().then(function (refreshedToken) {
        //        PlntFcmp.log('Token refreshed.');
        //        //PlntFcmp.setTokenSentToServer(false);
        //        PlntFcmp.sendTokenToServer(refreshedToken);
        //        //PlntFcmp.initToken();
        //    }).catch(function (err) {
        //        PlntFcmp.log('Unable to retrieve refreshed token ' + err);
        //    });
        //});

        PlntFcmp.messaging.onMessage(function (payload) {
            PlntFcmp.log('Message received. ', payload);
            PlntFcmp.appendMessage(payload);
        });

        /*navigator.serviceWorker.addEventListener('message', (event) => {
            console.log('message',event);
        });*/
        document.addEventListener("visibilitychange", function () {
            if (document.visibilityState === "visible") {
                PlntFcmp.reloadList();
            }
        });
    },
    unregisterAllServiceWorker: function () {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.ready.then(function (reg) {
                reg.unregister().then(function (successful) {
                    PlntFcmp.log('Unregister service worker result: ' + successful);
                });
            }).catch(function (error) {
                // registration failed
                PlntFcmp.log('Unregister failed with ' + error);
            });
        }
    },
    unregisterAddToHomeServiceWorker: function () {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                for (let registration of registrations) {
                    var filename = registration.active.scriptURL.split('/').pop();
                    if (filename === 'sw_add_home.js') {
                        registration.unregister();
                    }
                }
            }).catch(function (err) {
                PlntFcmp.log('Service Worker unregister failed: ', err);
            });
        }
    },
    unregisterPushNotificationServiceWorker: function () {
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.getRegistrations().then(function (registrations) {
                for (let registration of registrations) {
                    var filename = registration.active.scriptURL.split('/').pop();
                    if (filename === 'firebase-messaging-sw.js') {
                        registration.unregister();
                        PlntFcmp.log("DELETED " + filename);
                    }
                }
            }).catch(function (err) {
                PlntFcmp.log('Service Worker unregister failed: ', err);
            });
        }
    },
    initToken: function (/* function */ cb) {
        PlntFcmp.log('initToken()');

        PlntFcmp.messaging.getToken().then(function (currentToken) {
            window.localStorage.setItem('lastNotificationPermission', Notification.permission);
            if (currentToken) {
                PlntFcmp.log("initToken -> " + currentToken);
                //PlntFcmp.setTokenSentToServer(false);
                PlntFcmp.sendTokenToServer(currentToken, cb);
            } else {
                var msg = 'No Instance ID token available. Request permission to generate one.';
                PlntFcmp.log(msg);
                PlntFcmp.setTokenSentToServer(false);
            }
        }).catch(function (err) {
            PlntFcmp.log('Error retrieving Instance ID token. ' + err);
            PlntFcmp.setTokenSentToServer(false);
        });
    },
    log: function () {
        //return;
        console.log(...arguments);
    },
    sendTokenToServer: function (currentToken, /* function */ cb) {
        PlntFcmp.log('sendTokenToServer()');
        if (PlntFcmp.isTokenSentToServer()) {
            PlntFcmp.log("Token already sent to server so won't send it again unless it changes");
            return;
        }
        PlntFcmp.sendSubscriptionToBackEnd(currentToken);
    },
    isTokenSentToServer: function () {
        PlntFcmp.log('isTokenSentToServer()', window.localStorage.getItem('sentToServer') === '1');
        return window.localStorage.getItem('sentToServer') === '1';
    },
    setTokenSentToServer: function (sent) {
        PlntFcmp.log('setTokenSentToServer()', sent);
        window.localStorage.setItem('sentToServer', sent ? '1' : '0');
    },
    sendAllowSubscriptionToBackEnd: function (/* function */ cb) {
        PlntFcmp.log('sendAllowSubscriptionToBackEnd()');
        /*$.ajax({
            url: "/subscription-allow.php",
            dataType: 'json',
            error: function (xhr, status, error) {
                console.error('Something going wrong, please try later. (SendAllowSubscriptionToBackEnd)');
            },
            success: function (data) {
                if (cb instanceof Function) {
                    cb(data);
                }
            }
        });*/
    },
    requestPermission: function (/* function */ cb) {
        PlntFcmp.log('Push notification allowed, Requesting permission...');
        PlntFcmp.messaging.requestPermission().then(function () {
            PlntFcmp.log('Notification permission granted.');
            PlntFcmp.setTokenSentToServer(false);
            //PlntFcmp.setMacAddress(cb);
        }).catch(function (err) {
            PlntFcmp.log('Unable to get permission to notify.', err);
        });
    },
    deleteToken: function (/* function */ cb) {
        PlntFcmp.log('deleteToken()');
        PlntFcmp.messaging.getToken().then(function (currentToken) {
            PlntFcmp.messaging.deleteToken(currentToken).then(function () {
                PlntFcmp.log('Token deleted fcm.');
                PlntFcmp.setTokenSentToServer(false);

                if (cb instanceof Function) {
                    cb();
                }

            }).catch(function (err) {
                PlntFcmp.log('Unable to delete token. ', err);
            });
            // [END delete_token]
        }).catch(function (err) {
            PlntFcmp.log('Error retrieving Instance ID token. ', err);
        });
    },
    revokeToken: function (/* function */ cb) {
        PlntFcmp.log('deleteToken()');
        PlntFcmp.messaging.getToken().then(function (currentToken) {
            PlntFcmp.messaging.deleteToken(currentToken).then(function () {
                PlntFcmp.log('Token revoked fcm.');
                PlntFcmp.setTokenSentToServer(false);
                PlntFcmp.sendRevokeSubscriptionToBackEnd(currentToken, cb);
            }).catch(function (err) {
                PlntFcmp.log('Unable to delete token. ', err);
            });
            // [END delete_token]
        }).catch(function (err) {
            PlntFcmp.log('Error retrieving Instance ID token. ', err);
        });
    },
    clearSessionStorage: function (cb) {
        window.localStorage.removeItem('sentToServer');
        window.localStorage.removeItem('lastNotificationPermission');
        window.localStorage.removeItem('stopRequestPushNotification');
        if (cb instanceof Function) {
            cb();
        }
    },
    sendRevokeSubscriptionToBackEnd: function (subscription, /* function */cb) {
        PlntFcmp.log('sendRevokeSubscriptionToBackEnd()');
        return fetch('/AspNetUsers/UnsubscribePushNotification', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(subscription)
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('Bad status code from server.');
            }
            PlntFcmp.log('Token deleted ippoint.');
            if (cb instanceof Function) {
                cb();
            }

            return response.json();
        }).then(function (responseData) {
            if (!(responseData.data && responseData.data.success)) {
                throw new Error('Bad response from server.');
            }
        });
    },
    // Add a message to the messages element.
    appendMessage: function (payload) {
        PlntFcmp.setAlertMessage({ title: payload.notification.title, message: payload.notification.body })
        PlntFcmp.setAlertActive(true);
        PlntFcmp.reloadList();
    },
    reloadList: function () {
        if (Date.now() - PlntFcmp.lastUpdateList < PlntFcmp.updateListInterval) {
            return;
        }

        PlntFcmp.lastUpdateList = Date.now();

        store.dispatch(pendingVarList.Reload());
        store.dispatch(historyVarList.Reload());
        store.dispatch(activeVarList.Reload());
        store.dispatch(varSlice.Reload());
        PlntFcmp.log('List reloaded');
    },
    sendSubscriptionToBackEnd: function (subscription, /* function */cb) {
        PlntFcmp.log('sendSubscriptionToBackEnd()');
        return fetch('/AspNetUsers/SubscribePushNotification', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(subscription)
        }).then(function (response) {
            if (!response.ok) {
                throw new Error('Bad status code from server.');
            }
            PlntFcmp.setTokenSentToServer(true);
            PlntFcmp.log('Sent token to server');
            if (cb instanceof Function) {
                cb();
            }

            return response.json();
        });
    },
    checkPushSubscription: function (/* function */cbYes, /* function */cbNo) {
        PlntFcmp.log('checkPushSubscription()');
        PlntFcmp.messaging.getToken().then(function (refreshedToken) {
            PlntFcmp.log(refreshedToken);
            if (cbYes instanceof Function) {
                cbYes();
            }
        }).catch(function (err) {
            if (cbNo instanceof Function) {
                cbNo();
            }
        });
    },
    addHome: function () {
        PlntFcmp.log("Will the service worker register (addHome)?");
        window.addEventListener('load', function () {
            navigator.serviceWorker.register('/sw_add_home.js').then(
                function (reg) {
                    PlntFcmp.log('Service Worker (addHome) Registered!', reg);
                })
                .catch(function (err) {
                    PlntFcmp.log('Service Worker (addHome) registration failed: ', err);
                });
        });

        let deferredPrompt;


        window.addEventListener('beforeinstallprompt', (e) => {
            PlntFcmp.log('beforeinstallprompt fired');
            e.preventDefault();
            deferredPrompt = e;


            //divAddHomeObj.style.display = 'block';
            askAddToHome();
        });
        window.addEventListener('appinstalled', (evt) => {
            PlntFcmp.log('a2hs installed');

            /*$.ajax({
                url: "/js/auth/ajax.php",
                dataType: 'json',
                data: {
                    action: 'a2hs'
                },
                error: function (xhr, status, error) {
                },
                success: function (data) {
                    if (!data.success) {
                        $.cookie('addHome_installed_ts', data.date, { path: "/", secure: true });
                        $.cookie('addHome_installed_ts_tz', data.tz, { path: "/", secure: true });
                    }
                }
            });*/
        });

        var askAddToHome = function () {
            manageBrowserAddToHome();
        };

        var manageBrowserAddToHome = function () {
            deferredPrompt.prompt();
            deferredPrompt.userChoice
                .then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        PlntFcmp.log('User accepted the A2HS prompt');
                        stopViewAddHome();
                    } else {
                        PlntFcmp.log('User dismissed the A2HS prompt');
                    }
                    deferredPrompt = null;
                });
        };

        var stopViewAddHome = function () {
            /*$.cookie('addHome_visible', false, {path: "/", secure: true});
            $('#divAddHome').hide();*/
        };
        /*$('#btnCloseHome').on('click', function () {
            stopViewAddHome();
        });*/
    }
};

export default PlntFcmp